import { computed, ref, type Ref } from 'vue';
import { defineStore } from 'pinia';
import { useSharedApi } from '../../../api/shared.api';
import type { Crop } from '../models/crop.model';

export const useCropStore = defineStore('cropStore', () => {
  const cropApiService = useSharedApi().crop;
  const crops: Ref<Crop[]> = ref([]);

  const decisionSupportCrops = computed(() => {
    return crops.value.filter((crop) => !!crop.isDssCompatible);
  });

  const init = async () => {
    if (!crops.value.length) {
      await loadCrops();
    }
  };

  const loadCrops = async () => {
    const response = await cropApiService.listCrops();
    if (response.data) {
      crops.value = response.data;
    }
  };

  const findCropNameByCode = (code: string) => {
    return crops.value.find((crop) => crop.code === code)?.name;
  };

  init().then();

  return {
    crops,
    decisionSupportCrops,
    loadCrops,
    findCropNameByCode
  };
});
